// lib/state-stores/locationStore.ts
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export enum LocationTypeEnum {
  Home = 1,
  Work = 2,
  Other = 3,
}

export interface LocationDetails {
  name: string;
  type: number;
  details: string;
  street?: string;
  zip_code?: string;
  province?: string;
  typeArabicName?: string;
  typeEnglishName?: string;
  city?: string;
  country?: string;
  location: {
    latitude: number;
    longitude: number;
  };
}

type LocationState = {
  locationDetails: LocationDetails | null;
  setLocationDetails: (locationDetails: LocationDetails) => void;
};

export const useLocationStore = create<LocationState>()(
  devtools(
    (set, get) => ({
      locationDetails: null,
      setLocationDetails: (newLocationDetails: LocationDetails) => {
        const currentLocation = get().locationDetails;
        // Prevent update if no change
        if (
          currentLocation?.location.latitude === newLocationDetails.location.latitude &&
          currentLocation?.location.longitude === newLocationDetails.location.longitude &&
          currentLocation?.name === newLocationDetails.name
        ) {
          return;
        }
        set({ locationDetails: newLocationDetails });
      },
    }),
    { name: 'location-store' },
  ),
);
